import { Helmet } from "react-helmet-async";
import { BRAND, SEO_KEYWORDS } from "@/lib/site";

// Derive origin at render time so canonical/og URLs match the deployed host.
const siteOrigin =
  typeof window !== "undefined" && window.location?.origin
    ? window.location.origin
    : "";

/**
 * Per-page SEO helper. Renders <title>, meta description, canonical,
 * OpenGraph and Twitter tags.
 */
export default function SEO({
  title,
  description,
  path = "/",
  image,
}) {
  const fullTitle = title
    ? `${title} — ${BRAND.name}`
    : `${BRAND.name} — Personal Training & Fascial Stretch Therapy | Mississauga`;
  const desc =
    description ||
    `${BRAND.name}: mobility-focused personal training and Fascial Stretch Therapy in ${BRAND.location}. Move better, feel stronger, build long-term joint health.`;
  const url = `${siteOrigin}${path}`;
  const img = image || `${siteOrigin}/og-image.jpg`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="keywords" content={SEO_KEYWORDS.join(", ")} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={BRAND.name} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />

      {/* Robots */}
      <meta name="robots" content="index, follow, max-image-preview:large" />
    </Helmet>
  );
}
